import React from 'react';
import {
  formatCalendarDate,
  isDateInRange,
} from '@/modules/calendar/utils/calendar.helpers';
import {
  getCalendarGridEventTone,
} from '@/modules/calendar/config/calendarPage.config';

const COMPACT_EVENT_THRESHOLD = 3;
const MAX_COMPACT_EVENTS = 10;

export default function CalendarDateGrid({
  days = [],
  eventsByDate = {},
  selectedDate = '',
  selectedDateRange = {},
  monthLabel = '',
  onPreviousMonth,
  onNextMonth,
  onSelectDate,
  onOpenEvent,
}) {
  return (
    <section className="calendar-date-card" aria-label="Selezione data calendario">
      <div className="calendar-date-card__month" aria-label="Navigazione mese calendario">
        <button
          type="button"
          className="calendar-month-switcher__button"
          onClick={onPreviousMonth}
          aria-label="Mese precedente"
          title="Mese precedente"
        >
          ‹
        </button>
        <span className="calendar-month-switcher__label">{monthLabel}</span>
        <button
          type="button"
          className="calendar-month-switcher__button"
          onClick={onNextMonth}
          aria-label="Mese successivo"
          title="Mese successivo"
        >
          ›
        </button>
      </div>

      <div className="calendar-date-grid">
        {days.map((day) => {
          const dayEvents = eventsByDate[day.key] || [];
          const isSelected = selectedDate === day.key || day.key === selectedDateRange.startDate || day.key === selectedDateRange.endDate;
          const isInRange = isDateInRange(day.key, selectedDateRange) && Boolean(selectedDateRange.startDate && selectedDateRange.endDate);

          return (
            <article
              key={day.key}
              className={[
                'calendar-day-cell',
                isSelected ? 'is-selected' : '',
                isInRange ? 'is-in-range' : '',
              ].filter(Boolean).join(' ')}
              tabIndex={0}
              role="button"
              aria-label={`Seleziona ${formatCalendarDate(day.key)}`}
              onClick={() => onSelectDate(day.key)}
              onKeyDown={(event) => {
                if (event.target !== event.currentTarget) return;
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  onSelectDate(day.key);
                }
              }}
            >
              <div className="calendar-day-cell__head">
                <span>{day.weekday}</span>
                <strong>{day.dayNumber}</strong>
              </div>

              <div className="calendar-day-cell__events">
                {dayEvents.length > COMPACT_EVENT_THRESHOLD ? (
                  <div className="calendar-event-dots" aria-label={`${dayEvents.length} eventi`}>
                    {dayEvents.slice(0, MAX_COMPACT_EVENTS).map((eventItem) => {
                      const tone = getCalendarGridEventTone(eventItem.type);
                      const title = eventItem.title || 'Evento';

                      return (
                        <button
                          key={eventItem.id}
                          type="button"
                          className={`calendar-event-dot calendar-event-dot--${tone}`}
                          onClick={(event) => {
                            event.stopPropagation();
                            onOpenEvent(eventItem);
                          }}
                          aria-label={title}
                          title={title}
                        />
                      );
                    })}
                    {dayEvents.length > MAX_COMPACT_EVENTS ? (
                      <span className="calendar-day-cell__more">+{dayEvents.length - MAX_COMPACT_EVENTS}</span>
                    ) : null}
                  </div>
                ) : (
                  dayEvents.map((eventItem) => {
                    const tone = getCalendarGridEventTone(eventItem.type);
                    const title = eventItem.title || 'Evento';

                    return (
                      <button
                        key={eventItem.id}
                        type="button"
                        className={`calendar-event-pill calendar-event-pill--${tone}`}
                        onClick={(event) => {
                          event.stopPropagation();
                          onOpenEvent(eventItem);
                        }}
                        title={title}
                      >
                        <span className="calendar-event-pill__title">{title}</span>
                      </button>
                    );
                  })
                )}
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
